import { useEffect, useState } from 'react';
import { apiServerDac } from '../../../services/api';
import { DisciplinasEmentaComponent } from '@/components/PagesComponents/Graduacao/DisciplinasEmenta';
import { IDadosDisciplina } from '@/@types/Academico/Disciplina';


const DisciplinasEmenta = () => {
    const anoAtual = new Date().getFullYear();    
    const [ano, setAno] = useState(anoAtual);
    const [sigla, setSigla] = useState('');
    const [data, setData] = useState<IDadosDisciplina[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const getDisciplinasEmentaData = async () => {
            // server-dac V2 substitui /disciplinas/allyearsdistinct preservando { disciplinas }.
            const url = `/v2/disciplinas_catalogo/anos-distinct?ano=${!ano ? anoAtual : ano}&cod_disci=${sigla}&tipo=FA`

            setIsLoading(true);

            await apiServerDac.get(url)
                .then(response => {
                    setData(response.data.disciplinas);
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
        };

        getDisciplinasEmentaData();
    }, [ano, sigla]);


    return (
        <div>
            <h1>Graduação - Disciplinas - Programa</h1>

            <DisciplinasEmentaComponent
                isLoading={isLoading}
                setSigla={setSigla}
                setAno={setAno}
                sigla={sigla}
                data={data}
                ano={ano}
            />
        </div>
    );
}

export { DisciplinasEmenta };
